

























import { Component, Vue, Prop } from "vue-property-decorator";
import CardListRiwayatPasien from "@/components/pemeriksaan/riwayat/CardListRiwayatPasien.vue";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    CardListRiwayatPasien
  }
})
export default class NavRiwayat extends Vue {
  @Prop({ required: true }) rightDrawer: boolean;
  @Prop() rm: string;

  get stateuser() {
    return userModule.user;
  }

  get rightDrawerVal() {
    return this.rightDrawer;
  }
  set rightDrawerVal(r: boolean) {
    this.rightDrawer = r;
    // console.log("openRightDrawer ", this.rightDrawer);

    // this.panel = null;
  }

  // public right = true;

  created() {}

  mounted() {
    this.$nextTick(() => {});
  }
  detailRiwayat() {
    this.$router.push({
      name: `detail-pasien`,
      params: {
        rm: this.rm
      }
    });
  }
}
